module.exports = __webpack_public_path__ + "static/media/express.1ec0d310.png";